import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import useStatuses from "../context/status/useStatuses";
import { STUDENT_STATUS } from "../constants/student.status";
import { useStudents } from "../context/students";
import Preloader from "../components/Preloader";

export const DynamicRedirect = () => {
    const { students, activeStudentId, onChangeActiveStudentId } = useStudents();
    const { studentStatus } = useStatuses();
    const navigate = useNavigate();
    const location = useLocation();

    const redirectPath = studentStatus === STUDENT_STATUS.STUDENT
        ? "/home"
        : "/dashboard";

    useEffect(() => {
        if (!activeStudentId && students?.[0]?.studentId) onChangeActiveStudentId(students?.[0]?.studentId);
    }, [activeStudentId, students]);

    useEffect(() => {
        const isOnApplicantDashboard = location.pathname.startsWith("/dashboard");
        const isOnStudentDashboard = location.pathname.startsWith("/home");

        if (studentStatus === STUDENT_STATUS.STUDENT && isOnApplicantDashboard) {
            navigate(`/home/${activeStudentId}`, { replace: true });
        } else if ([STUDENT_STATUS.APPLICANT, STUDENT_STATUS.RETURNER].includes(studentStatus) && isOnStudentDashboard) {
            navigate(`/dashboard/${activeStudentId}`, { replace: true });
        }
    }, [studentStatus, activeStudentId, location.pathname, navigate]);

    if (!activeStudentId) return <Preloader isLoading />;

    return <Navigate to={`${redirectPath}/${activeStudentId || ""}`} replace />;
};
